import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-204" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-line border-l-4 border-l-green bg-white p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-205" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow" aria-label="Cerrar aviso" data-id="element-206" data-mp="hgfel1n43sjy">
            <XIcon className="h-4 w-4" data-id="element-207" data-mp="1jeg5siu6ui6o" />
          </button>
          <div className="flex gap-3" data-id="element-208" data-mp="1ngjjzf88s0vn">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-green" aria-hidden="true" data-id="element-209" data-mp="1nfi6z57o14ba" />
            <div data-id="element-210" data-mp="19omw5ndlwd52">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-green" data-id="element-211" data-mp="19o3nyydrd348">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-212" data-mp="1ei7trebaf53q">
                Al completar tu compra recibís el<br data-id="element-213" data-mp="zp5rn9a3c5ao" />
                <span className="font-bold text-navy" data-id="element-214" data-mp="14qbmbcnba2mu">Mega Pack Topografía Listo</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-215" data-mp="qqkg3y31dqje">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}